import React from 'react';
import { Loader } from '@yabble/yabble-component-library/Loader';
import { Stack } from '@yabble/yabble-component-library/Stack';

export const LoadingPage: React.FC = () => (
  <Stack align="center" justify="center" stretch>
    <Loader size="regular" />
  </Stack>
);
